<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import WhatsappPhonePreview from 'dashboard/components-next/template-preview/WhatsappPhonePreview.vue';
import { parseTemplateComponents } from 'dashboard/helper/messageTemplateComponents';
import { stripMarkdownHardBreaks } from 'dashboard/helper/whatsappTemplateFormatter';

const { t } = useI18n();

const dialogRef = ref(null);
const template = ref(null);

// Rascunhos salvos antes da conversão para o formato do WhatsApp ainda podem trazer
// o "\" de quebra de linha do markdown.
const preview = computed(() => {
  const parsed = parseTemplateComponents(template.value?.components);
  return {
    headerText: parsed.headerText,
    headerMediaType: parsed.headerMediaType,
    bodyText: stripMarkdownHardBreaks(parsed.bodyText),
    footerText: parsed.footerText,
    buttons: parsed.buttons,
  };
});

const open = selectedTemplate => {
  template.value = selectedTemplate;
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('INBOX_MGMT.MESSAGE_TEMPLATES.PREVIEW_DIALOG.TITLE')"
    :show-confirm-button="false"
    :cancel-button-label="
      t('INBOX_MGMT.MESSAGE_TEMPLATES.PREVIEW_DIALOG.CLOSE')
    "
  >
    <WhatsappPhonePreview v-bind="preview" />
  </Dialog>
</template>
